import styled from 'styled-components';
import { Select } from '../../../select';
import { getColor, getSizeBy } from '../../../../../src/styled/utils';
import { Button } from '../../../button';
import { Subtitle1Styles } from '../../../typography';
import { ListItem } from '../../../list-item';
export const ConnectSelect = styled(Select) `
  min-width: 96px;
  background-color: ${getColor('primary')};
`;
export const ConnectButton = styled(Button) `
  padding: 6px 12px 6px 13px;
  column-gap: ${getSizeBy(1)};

  & > .text {
    ${Subtitle1Styles}
  }
`;
export const ListItemStyled = styled(ListItem) `
  min-width: 250px;
`;
